<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Przywracanie ustawień tabel</h4>
              <button type="button" @click="openAddModal" class="btn btn-primary btn-sm me-2">
                <i class="bi bi-plus-circle me-2"></i>
                Dodaj
              </button>
              <button type="button" @click="openTableTypesModal" class="btn btn-outline-primary btn-sm">
                <i class="bi bi-table me-2"></i>
                Rodzaje tabel
              </button>
            </div>
          </div>
        </div>

        <div class="widget-content">
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Tabela</th>
                    <th>Status</th>
                    <th>Utworzono</th>
                    <th>Opcje</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="item in restoreTableLocal" :key="item.id">
                    <td>
                      {{ getRestoreTableName(item.table_id) }}
                    </td>

                    <td>
                      <span class="badge" :class="Number(item.status) === 1
                          ? 'bg-success'
                          : 'bg-secondary'
                        ">
                        {{
                          Number(item.status) === 1
                            ? 'Aktywna'
                            : 'Nieaktywna'
                        }}
                      </span>
                    </td>

                    <td>
                      {{ formatDate(item.created_at) }}
                    </td>

                    <td>
                      <button type="button" class="btn btn-sm btn-outline-primary me-2 mb-2"
                        @click="openUsersModal(item)">
                        <i class="bi bi-people me-2"></i>
                        Osoby
                      </button>

                      <button type="button" class="btn btn-sm btn-outline-info me-2 mb-2" @click="editRestore(item)">
                        <i class="bi bi-pencil me-2"></i>
                        Edytuj
                      </button>

                      <button type="button" class="btn btn-sm btn-danger mb-2" @click="deleteRestore(item.id)">
                        <i class="bi bi-trash me-2"></i>
                        Usuń
                      </button>
                    </td>
                  </tr>

                  <tr v-if="restoreTableLocal.length === 0">
                    <td colspan="5" class="text-center text-muted py-4">
                      Brak przywracania ustawień.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="isAddModalOpen" class="modal fade show" tabindex="-1"
            style="display: block; background: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-md modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    Dodaj przywracanie ustawień
                  </h5>
                  <button type="button" class="btn-close" @click="closeAddModal"></button>
                </div>

                <div class="modal-body">
                  <label class="form-label">
                    Tabela:
                  </label>

                  <select v-model="newRestore.table_id" class="form-select">
                    <option value="">
                      Wybierz tabelę
                    </option>

                    <option v-for="table in restoreTableList" :key="table.restore_table_id"
                      :value="table.restore_table_id">
                      {{ table.restore_table_name }}
                    </option>
                  </select>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeAddModal">
                    Anuluj
                  </button>

                  <button type="button" class="btn btn-primary" :disabled="!newRestore.table_id" @click="saveRestore">
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isEditModalOpen" class="modal fade show" tabindex="-1"
            style="display: block; background: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-md modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    Edycja przywracania ustawień
                  </h5>
                  <button type="button" class="btn-close" @click="closeEditModal"></button>
                </div>

                <div class="modal-body">
                  <div class="mb-3">
                    <label class="form-label">
                      Tabela:
                    </label>
                    <select v-model="editedRestore.table_id" class="form-select">
                      <option value="">
                        Wybierz tabelę
                      </option>

                      <option v-for="table in restoreTableList" :key="table.restore_table_id"
                        :value="table.restore_table_id">
                        {{ table.restore_table_name }}
                      </option>
                    </select>
                  </div>

                  <div class="mb-3">
                    <label class="form-label">
                      Status:
                    </label>
                    <select v-model.number="editedRestore.status" class="form-select">
                      <option :value="1">
                        Aktywna
                      </option>
                      <option :value="0">
                        Nieaktywna
                      </option>
                    </select>
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeEditModal">
                    Anuluj
                  </button>
                  <button type="button" class="btn btn-primary" @click="updateRestore">
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isTableTypesModalOpen" class="modal fade show" tabindex="-1"
            style="display: block; background: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    Rodzaje tabel
                  </h5>
                  <button type="button" class="btn-close" @click="closeTableTypesModal"></button>
                </div>

                <div class="modal-body">
                  <div class="d-flex justify-content-end mb-3">
                    <button type="button" class="btn btn-primary btn-sm" @click="openAddTableTypeModal">
                      <i class="bi bi-plus-circle me-2"></i>
                      Dodaj rodzaj tabeli
                    </button>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-hover table-bordered align-middle">
                      <thead>
                        <tr>
                          <th>Nazwa tabeli</th>
                          <th>ID tabeli</th>
                          <th>Opcje</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="table in restoreTableListLocal" :key="table.id">
                          <td>
                            {{ table.restore_table_name }}
                          </td>
                          <td>
                            {{ table.restore_table_id }}
                          </td>
                          <td>
                            <button type="button" class="btn btn-sm btn-outline-info me-2"
                              @click="editTableType(table)">
                              <i class="bi bi-pencil me-2"></i>
                              Edytuj
                            </button>

                            <button type="button" class="btn btn-sm btn-danger" @click="deleteTableType(table.id)">
                              <i class="bi bi-trash me-2"></i>
                              Usuń
                            </button>
                          </td>
                        </tr>

                        <tr v-if="restoreTableListLocal.length === 0">
                          <td colspan="4" class="text-center text-muted py-4">
                            Brak rodzajów tabel.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeTableTypesModal">
                    Zamknij
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isAddTableTypeModalOpen" class="modal fade show" tabindex="-1"
            style="display: block; background: rgba(0, 0, 0, 0.65); z-index: 1060;">
            <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    Dodaj rodzaj tabeli
                  </h5>

                  <button type="button" class="btn-close" @click="closeAddTableTypeModal"></button>
                </div>

                <div class="modal-body">

                  <div class="mb-3">
                    <label class="form-label">
                      Nazwa tabeli:
                    </label>

                    <input v-model="newTableType.restore_table_name" type="text" class="form-control" maxlength="200">
                  </div>
                  <div class="mb-3">
                    <label class="form-label">
                      ID tabeli:
                    </label>

                    <input v-model="newTableType.restore_table_id" type="text" class="form-control" maxlength="200">
                  </div>

                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeAddTableTypeModal">
                    Anuluj
                  </button>

                  <button type="button" class="btn btn-primary" :disabled="!newTableType.restore_table_id ||
                    !newTableType.restore_table_name
                    " @click="saveTableType">
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isEditTableTypeModalOpen" class="modal fade show" tabindex="-1"
            style="display: block; background: rgba(0, 0, 0, 0.65); z-index: 1060;">
            <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    Edycja rodzaju tabeli
                  </h5>

                  <button type="button" class="btn-close" @click="closeEditTableTypeModal"></button>
                </div>

                <div class="modal-body">
                  <div class="mb-3">
                    <label class="form-label">
                      Nazwa tabeli:
                    </label>

                    <input v-model="editedTableType.restore_table_name" type="text" class="form-control"
                      maxlength="200">
                  </div>
                  <div class="mb-3">
                    <label class="form-label">
                      ID tabeli:
                    </label>

                    <input v-model="editedTableType.restore_table_id" type="text" class="form-control" maxlength="200">
                  </div>


                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeEditTableTypeModal">
                    Anuluj
                  </button>

                  <button type="button" class="btn btn-primary" :disabled="!editedTableType.restore_table_id ||
                    !editedTableType.restore_table_name
                    " @click="updateTableType">
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isUsersModalOpen" class="modal fade show" tabindex="-1"
            style="display: block; background: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <div>
                    <h5 class="modal-title mb-1">
                      Osoby
                    </h5>

                    <small v-if="selectedRestore" class="text-muted">
                      {{ getRestoreTableName(selectedRestore.table_id) }}
                    </small>
                  </div>

                  <button type="button" class="btn-close" @click="closeUsersModal"></button>
                </div>

                <div class="modal-body">
                  <div v-if="isLoadingUsers" class="text-center py-5">
                    <div class="spinner-border" role="status"></div>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table table-hover table-bordered align-middle">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Nazwisko</th>
                          <th>Imię</th>
                          <th>User ID</th>
                          <th>Utworzono</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="(item, index) in restoreTableDataLocal" :key="item.id">
                          <td>
                            {{ index + 1 }}
                          </td>

                          <td>
                            {{ item.user?.last_name || '' }}
                          </td>

                          <td>
                            {{ item.user?.first_name || '' }}
                          </td>

                          <td>
                            {{ item.user_id }}
                          </td>

                          <td>
                            {{ formatDate(item.created_at) }}
                          </td>
                        </tr>

                        <tr v-if="restoreTableDataLocal.length === 0">
                          <td colspan="5" class="text-center text-muted py-4">
                            Brak osób przypisanych do tego przywracania.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeUsersModal">
                    Zamknij
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";

export default {
  components: {
    AppLayout
  },

  props: {
    restoreTable: {
      type: Array,
      default: () => []
    },

    restoreTableData: {
      type: Array,
      default: () => []
    },

    restoreTableList: {
      type: Array,
      default: () => []
    },

    selectedRestoreId: {
      type: [Number, String],
      default: null
    }
  },

  data() {
    return {
      restoreTableLocal: [],
      restoreTableDataLocal: [],
      restoreTableListLocal: [],

      selectedRestore: null,

      newRestore: {
        table_id: ''
      },

      editedRestore: {
        id: null,
        table_id: '',
        status: 1
      },

      newTableType: {
        restore_table_id: '',
        restore_table_name: ''
      },

      editedTableType: {
        id: null,
        restore_table_id: '',
        restore_table_name: ''
      },

      isAddModalOpen: false,
      isEditModalOpen: false,
      isUsersModalOpen: false,
      isLoadingUsers: false,

      isTableTypesModalOpen: false,
      isAddTableTypeModalOpen: false,
      isEditTableTypeModalOpen: false
    };
  },

  mounted() {
    this.restoreTableLocal = this.restoreTable.map(item => ({
      ...item
    }));

    this.restoreTableDataLocal = this.restoreTableData.map(item => ({
      ...item
    }));

    this.restoreTableListLocal = this.restoreTableList.map(item => ({
      ...item
    }));
  },

  methods: {
    formatDate(timestamp) {
      if (!timestamp) {
        return '';
      }

      const date = new Date(timestamp);

      if (Number.isNaN(date.getTime())) {
        return '';
      }

      return date.toLocaleDateString('pl-PL');
    },

    getRestoreTableName(tableId) {
      const table = this.restoreTableListLocal.find(
        item =>
          String(item.restore_table_id) === String(tableId)
      );

      return table
        ? table.restore_table_name
        : tableId;
    },

    openAddModal() {
      this.newRestore = {
        table_id: ''
      };

      this.isAddModalOpen = true;
    },

    closeAddModal() {
      this.isAddModalOpen = false;

      this.newRestore = {
        table_id: ''
      };
    },

    saveRestore() {
      if (!this.newRestore.table_id) {
        return;
      }

      this.$inertia.post(
        route('admin.tables.reset.dodaj'),
        {
          table_id: this.newRestore.table_id
        },
        {
          preserveScroll: true,

          onSuccess: page => {
            this.isAddModalOpen = false;

            this.newRestore = {
              table_id: ''
            };

            if (page.props.restoreTable) {
              this.restoreTableLocal = page.props.restoreTable.map(item => ({
                ...item
              }));
            }

            if (page.props.restoreTableList) {
              this.restoreTableListLocal = page.props.restoreTableList.map(item => ({
                ...item
              }));
            }

            Toast.fire({
              toast: true,
              icon: 'success',
              title: 'Zapisano',
              html: 'Przywracanie ustawień zostało dodane.',
              position: 'top-end',
              timer: 3000,
              showConfirmButton: false
            });
          },

          onError: () => {
            Toast.fire({
              toast: true,
              icon: 'error',
              title: 'Błąd',
              html: 'Nie udało się dodać przywracania ustawień.',
              position: 'top-end',
              timer: 4000,
              showConfirmButton: false
            });
          }
        }
      );
    },

    editRestore(item) {
      this.editedRestore = {
        id: item.id,
        table_id: String(item.table_id),
        status: Number(item.status)
      };

      this.isEditModalOpen = true;
    },

    closeEditModal() {
      this.isEditModalOpen = false;

      this.editedRestore = {
        id: null,
        table_id: '',
        status: 1
      };
    },

    updateRestore() {
      if (!this.editedRestore.id) {
        return;
      }

      if (!this.editedRestore.table_id) {
        return;
      }

      const updatedId = this.editedRestore.id;
      const updatedTableId = this.editedRestore.table_id;
      const updatedStatus = Number(this.editedRestore.status);

      this.$inertia.put(
        route('admin.tables.reset.update', updatedId),
        {
          table_id: updatedTableId,
          status: updatedStatus
        },
        {
          preserveScroll: true,

          onSuccess: page => {
            this.isEditModalOpen = false;

            if (page.props.restoreTable) {
              this.restoreTableLocal = page.props.restoreTable.map(item => ({
                ...item
              }));
            }

            if (page.props.restoreTableList) {
              this.restoreTableListLocal = page.props.restoreTableList.map(item => ({
                ...item
              }));
            }

            this.editedRestore = {
              id: null,
              table_id: '',
              status: 1
            };

            Toast.fire({
              toast: true,
              icon: 'success',
              title: 'Zapisano',
              html: 'Przywracanie ustawień zostało zaktualizowane.',
              position: 'top-end',
              timer: 3000,
              showConfirmButton: false
            });
          },

          onError: () => {
            Toast.fire({
              toast: true,
              icon: 'error',
              title: 'Błąd',
              html: 'Nie udało się zaktualizować przywracania ustawień.',
              position: 'top-end',
              timer: 4000,
              showConfirmButton: false
            });
          }
        }
      );
    },

    deleteRestore(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie przywracania',
        html: 'Czy na pewno chcesz usunąć wybrane przywracanie oraz wszystkie przypisane do niego osoby?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak, usuń',
        denyButtonText: 'Anuluj',
        timer: false,
        position: 'center'
      }).then(result => {
        if (!result.isConfirmed) {
          return;
        }

        this.$inertia.delete(
          route('admin.tables.reset.usun', id),
          {
            preserveScroll: true,

            onSuccess: page => {
              this.restoreTableLocal = this.restoreTableLocal.filter(
                item => item.id !== id
              );

              if (
                this.selectedRestore &&
                this.selectedRestore.id === id
              ) {
                this.closeUsersModal();
              }

              if (page.props.restoreTable) {
                this.restoreTableLocal = page.props.restoreTable.map(item => ({
                  ...item
                }));
              }

              if (page.props.restoreTableList) {
                this.restoreTableListLocal = page.props.restoreTableList.map(item => ({
                  ...item
                }));
              }

              Toast.fire({
                toast: true,
                icon: 'success',
                title: 'Usunięto',
                html: 'Przywracanie oraz wszystkie przypisane osoby zostały usunięte.',
                position: 'top-end',
                timer: 3000,
                showConfirmButton: false
              });
            },

            onError: () => {
              Toast.fire({
                toast: true,
                icon: 'error',
                title: 'Błąd',
                html: 'Nie udało się usunąć przywracania.',
                position: 'top-end',
                timer: 4000,
                showConfirmButton: false
              });
            }
          }
        );
      });
    },

    openUsersModal(item) {
      this.selectedRestore = {
        ...item
      };

      this.restoreTableDataLocal = [];
      this.isUsersModalOpen = true;
      this.isLoadingUsers = true;

      axios
        .post(
          route('admin.tables.get.data'),
          {
            id: item.id
          }
        )
        .then(response => {
          this.restoreTableDataLocal = (
            response.data.restoreTableData || []
          ).map(item => ({
            ...item
          }));
        })
        .catch(() => {
          this.restoreTableDataLocal = [];

          Toast.fire({
            toast: true,
            icon: 'error',
            title: 'Błąd',
            html: 'Nie udało się pobrać listy osób.',
            position: 'top-end',
            timer: 4000,
            showConfirmButton: false
          });
        })
        .finally(() => {
          this.isLoadingUsers = false;
        });
    },

    closeUsersModal() {
      this.isUsersModalOpen = false;
      this.selectedRestore = null;
      this.restoreTableDataLocal = [];
      this.isLoadingUsers = false;
    },

    openTableTypesModal() {
      this.restoreTableListLocal = this.restoreTableList.map(item => ({
        ...item
      }));

      this.isTableTypesModalOpen = true;
    },

    closeTableTypesModal() {
      this.isTableTypesModalOpen = false;
      this.closeAddTableTypeModal();
      this.closeEditTableTypeModal();
    },

    openAddTableTypeModal() {
      this.newTableType = {
        restore_table_id: '',
        restore_table_name: ''
      };

      this.isAddTableTypeModalOpen = true;
    },

    closeAddTableTypeModal() {
      this.isAddTableTypeModalOpen = false;

      this.newTableType = {
        restore_table_id: '',
        restore_table_name: ''
      };
    },

    saveTableType() {
      if (
        !this.newTableType.restore_table_id ||
        !this.newTableType.restore_table_name
      ) {
        return;
      }

      this.$inertia.post(
        route('admin.tables.reset.lista.dodaj'),
        {
          restore_table_id: this.newTableType.restore_table_id,
          restore_table_name: this.newTableType.restore_table_name
        },
        {
          preserveScroll: true,

          onSuccess: page => {
            this.closeAddTableTypeModal();

            if (page.props.restoreTableList) {
              this.restoreTableListLocal = page.props.restoreTableList.map(item => ({
                ...item
              }));
            }

            Toast.fire({
              toast: true,
              icon: 'success',
              title: 'Zapisano',
              html: 'Rodzaj tabeli został dodany.',
              position: 'top-end',
              timer: 3000,
              showConfirmButton: false
            });
          },

          onError: () => {
            Toast.fire({
              toast: true,
              icon: 'error',
              title: 'Błąd',
              html: 'Nie udało się dodać rodzaju tabeli.',
              position: 'top-end',
              timer: 4000,
              showConfirmButton: false
            });
          }
        }
      );
    },

    editTableType(table) {
      this.editedTableType = {
        id: table.id,
        restore_table_id: String(table.restore_table_id),
        restore_table_name: table.restore_table_name
      };

      this.isEditTableTypeModalOpen = true;
    },

    closeEditTableTypeModal() {
      this.isEditTableTypeModalOpen = false;

      this.editedTableType = {
        id: null,
        restore_table_id: '',
        restore_table_name: ''
      };
    },

    updateTableType() {
      if (!this.editedTableType.id) {
        return;
      }

      if (
        !this.editedTableType.restore_table_id ||
        !this.editedTableType.restore_table_name
      ) {
        return;
      }

      const id = this.editedTableType.id;

      this.$inertia.put(
        route('admin.tables.reset.lista.update', id),
        {
          restore_table_id: this.editedTableType.restore_table_id,
          restore_table_name: this.editedTableType.restore_table_name
        },
        {
          preserveScroll: true,

          onSuccess: page => {
            this.closeEditTableTypeModal();

            if (page.props.restoreTableList) {
              this.restoreTableListLocal = page.props.restoreTableList.map(item => ({
                ...item
              }));
            }

            Toast.fire({
              toast: true,
              icon: 'success',
              title: 'Zapisano',
              html: 'Rodzaj tabeli został zaktualizowany.',
              position: 'top-end',
              timer: 3000,
              showConfirmButton: false
            });
          },

          onError: () => {
            Toast.fire({
              toast: true,
              icon: 'error',
              title: 'Błąd',
              html: 'Nie udało się zaktualizować rodzaju tabeli.',
              position: 'top-end',
              timer: 4000,
              showConfirmButton: false
            });
          }
        }
      );
    },

    deleteTableType(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie rodzaju tabeli',
        html: 'Czy na pewno chcesz usunąć wybrany rodzaj tabeli?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak, usuń',
        denyButtonText: 'Anuluj',
        timer: false,
        position: 'center'
      }).then(result => {
        if (!result.isConfirmed) {
          return;
        }

        this.$inertia.delete(
          route('admin.tables.reset.lista.usun', id),
          {
            preserveScroll: true,

            onSuccess: page => {
              this.restoreTableListLocal =
                this.restoreTableListLocal.filter(
                  item => item.id !== id
                );

              if (page.props.restoreTableList) {
                this.restoreTableListLocal =
                  page.props.restoreTableList.map(item => ({
                    ...item
                  }));
              }

              Toast.fire({
                toast: true,
                icon: 'success',
                title: 'Usunięto',
                html: 'Rodzaj tabeli został usunięty.',
                position: 'top-end',
                timer: 3000,
                showConfirmButton: false
              });
            },

            onError: () => {
              Toast.fire({
                toast: true,
                icon: 'error',
                title: 'Błąd',
                html: 'Nie udało się usunąć rodzaju tabeli.',
                position: 'top-end',
                timer: 4000,
                showConfirmButton: false
              });
            }
          }
        );
      });
    }
  }
};
</script>
